document.addEventListener('DOMContentLoaded', function () {
  const testSwiper = document.getElementById('reviews-testimonials-swiper');
  if (!testSwiper || typeof Swiper === 'undefined') return;

  const bullets = document.querySelectorAll('.reviews-testimonials-pagination .swiper-pagination-bullet');
  const bulletsBySlide = {};

  bullets.forEach(function (bullet) {
    const slideIndex = bullet.getAttribute('data-slide-index');
    if (!bulletsBySlide[slideIndex]) bulletsBySlide[slideIndex] = [];
    bulletsBySlide[slideIndex].push(bullet);
  });
  const VISIBILITY_THRESHOLD = 0.5;

  const swiper = new Swiper('#reviews-testimonials-swiper', {
    slidesPerView: 1.1,
    spaceBetween: 8,
    grabCursor: true,
    watchSlidesProgress: true,
    breakpoints: {
      1560: {
        slidesPerView: 3.45,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 3.3,
        spaceBetween: 24,
      },
    },
    on: {
      init: function () {
        setActiveBullets(this);
      },
      slideChange: function () {
        setActiveBullets(this);
      },
      setTranslate: function () {
        setActiveBullets(this);
      },
      transitionEnd: function () {
        setActiveBullets(this);
      },
      breakpoint: function () {
        setActiveBullets(this);
      },
      resize: function () {
        setActiveBullets(this);
      },
    },
  });

  bullets.forEach(function (bullet) {
    bullet.addEventListener('click', function () {
      const index = parseInt(bullet.getAttribute('data-slide-index'), 10);
      swiper.slideTo(index);
    });
  });

  function setActiveBullets(swiperInstance) {
    const containerRect = swiperInstance.el.getBoundingClientRect();

    swiperInstance.slides.forEach(function (slide, index) {
      const slideBullets = bulletsBySlide[index];
      if (!slideBullets) return;

      const slideRect = slide.getBoundingClientRect();
      const visibleWidth = Math.min(slideRect.right, containerRect.right) - Math.max(slideRect.left, containerRect.left);
      const visibleRatio = slideRect.width > 0 ? Math.max(0, visibleWidth) / slideRect.width : 0;

      slideBullets.forEach(function (bullet) {
        bullet.classList.toggle('swiper-pagination-bullet-active', visibleRatio >= VISIBILITY_THRESHOLD);
      });
    });
  }
});
